import { PrimaryButton } from '@/app/components/PrimaryButton'
import { SecondaryButton } from '@/app/components/SecondaryButton'
import { ROUTES } from '@/app/lib/constants'
import { ErrorPageWithImage } from '@/app/modules/shared/components/error'
import { useIntl } from 'react-intl'

export default function AccessDeniedPage() {
  const intl = useIntl()

  return (
    <ErrorPageWithImage
      title={intl.formatMessage({
        id: 'AccessDenied.title',
        defaultMessage: 'Access Denied',
      })}
      pageTitle={intl.formatMessage({
        id: 'AccessDenied.pageTitle',
        defaultMessage: '403 - Access Denied',
      })}
      description={intl.formatMessage({
        id: 'AccessDenied.description',
        defaultMessage: "You don't have permission to access this page.",
      })}
      mobileImage="/images/access-denied-mobile.png"
      desktopImage="/images/access-denied-desktop.png"
      alt={intl.formatMessage({
        id: 'AccessDenied.alt',
        defaultMessage: 'Access denied illustration',
      })}
    >
      <div className="flex gap-3">
        <PrimaryButton href={ROUTES.homepage}>
          {intl.formatMessage({
            id: 'AccessDenied.backToHome',
            defaultMessage: 'Back to Home',
          })}
        </PrimaryButton>
        <SecondaryButton href={ROUTES.logout}>
          {intl.formatMessage({
            id: 'AccessDenied.logout',
            defaultMessage: 'Logout',
          })}
        </SecondaryButton>
      </div>
    </ErrorPageWithImage>
  )
}
